import type { BadgeRule } from "~/lib/badges/types";

export const dateValidityRule: BadgeRule = {
  name: "dateValidity",
  evaluate: (_product, badge) => {
    const now = Date.now();
    if (badge.startDateTime !== undefined && now < badge.startDateTime) return false;
    if (badge.endDateTime !== undefined && now > badge.endDateTime) return false;
    return true;
  },
};
